<template>
  <div id="app">
    <Preloader></Preloader>
    <DesktopNavigation class="d-none d-lg-block"></DesktopNavigation>
    <MobileNavigation class="d-block d-lg-none"></MobileNavigation>
    <router-view></router-view>
    <GotoTop class="d-none d-lg-block"></GotoTop>
    <Footer></Footer>
  </div>
</template>

<script>
import Preloader from "@/components/Preloader.vue";
import DesktopNavigation from "@/components/DesktopNavigation.vue";
import MobileNavigation from "@/components/MobileNavigation.vue";
import Footer from "@/components/Footer.vue";
import GotoTop from "@/components/GotoTop.vue";

export default {
  name: "App",
  components: {
    Preloader,
    DesktopNavigation,
    MobileNavigation,
    GotoTop,
    Footer
  },
};
</script>

<style lang="sass">
body
  overflow-x: hidden
  color: $dutche-primary-violet
  font-family: "Gotham"
</style>
